export const LABELS_LIST_KEY = 'LABELS_LIST';
export const LABELS_ONE_KEY = 'LABELS_ONE_KEY';
